import Screen38496Home from '@/components/screen38496'


export default {
  path: '/screen38496',
  component: Screen38496Home
}



// WEBPACK FOOTER //
// ./src/router/screen38496.js